import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {
  DangerInformation,
  Exemption_7_1_1
} from '@portbase/bezoekschip-service-typescriptmodels';
import {ExemptionBaseComponent} from "../../common/exemption_base/exemption_base.component";
import {PortvisitUtils} from "../../../../../refdata/portvisit-utils";

@Component({
    selector: 'app-visit-exemptions-exemption-7-1-1',
    templateUrl: './exemption_7_1_1.component.html',
    styleUrls: ['./exemption_7_1_1.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Exemption_7_1_1Component extends ExemptionBaseComponent {

  @Input() exemption: Exemption_7_1_1;

  portVisitUtils = PortvisitUtils;
  dangerousGoods?: DangerInformation;
}
